<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
    <div class="entity-config-shell d-flex flex-column gap-4 gap-lg-3 mx-auto">
        <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
            <div class="entity-config-top-hero px-2 px-md-3 py-3">
                <div class="row g-2 align-items-start flex-nowrap">
                    <div class="col">
                        <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Manual Verification Forms</h1>
                        <p class="entity-page-subtitle text-white mb-0">
                            Create forms used for manual verification flows.
                        </p>
                    </div>

                    <div class="col-auto d-flex justify-content-end">
                        <button type="button"
                           class="btn btn-primary-dark text-xs d-inline-flex align-items-center rounded-3 px-3 py-2 shadow-sm me-2 align-self-end"
                            data-bs-toggle="modal" data-bs-target="#create_verification_form"
                            @click="open_create_form_modal">
                            <i class="bi bi-plus-circle-fill me-2 text-white"></i>
                            <span>Create New Form</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <section class="d-flex flex-column gap-3">
            <div class="card border-0 shadow-sm rounded-4 overflow-hidden">
                <div class="card-body p-3 p-md-4">

                    <div v-if="loading_forms" class="text-secondary text-xs">
                        Loading verification forms...
                    </div>

                    <div v-else-if="!(verification_forms || []).length" class="card border-0 shadow-sm rounded-4">
                        <div class="card-body p-4 p-md-5 text-center text-secondary">
                            <div
                                class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center mb-3 p-3 lh-1">
                                <i class="bi bi-ui-checks-grid fs-5"></i>
                            </div>
                            <div class="fw-semibold text-x mb-1">No manual verification forms found</div>
                            <div class="text-xs">
                                Use the <b>Create New Form</b> button in the header to add your first manual verification form.
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div
                            class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
                            <div class="row g-2 align-items-center">
                                <div class="col-lg-5">Form</div>
                                <div class="col-lg-2">Status</div>
                                <div class="col-lg-2">Created</div>
                                <div class="col-lg-3 text-end">Actions</div>
                            </div>
                        </div>

                        <section class="d-flex flex-column gap-2">
                            <article v-for="form in (verification_forms || [])"
                                :key="form.manual_verification_form_id || form.form_id || form.form_name"
                                class="entity-row-card bg-white rounded-4 border border-purple border-opacity-50 shadow-sm p-2">
                                <div class="row g-2 align-items-center">
                                    <div class="col-12 col-lg-5 d-flex align-items-start align-items-sm-center gap-3">
                                        <div
                                            class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0">
                                            <i class="bi bi-ui-checks-grid"></i>
                                        </div>
                                        <div class="min-w-0">
                                            <div class="fw-bold text-x text-truncate">{{ form.form_name || 'Untitled Form' }}</div>
                                            <div class="text-secondary text-xs text-wrap text-break">
                                                {{ form.form_description || 'No description provided.' }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-4 col-lg-2">
                                        <span
                                            class="entity-status-pill d-inline-flex align-items-center justify-content-center fw-bold text-uppercase"
                                            :class="form.is_active ? 'entity-status-active text-primary' : 'bg-white border text-secondary'">
                                            {{ form.is_active ? 'active' : 'inactive' }}
                                        </span>
                                    </div>

                                    <div class="col-12 col-sm-5 col-lg-2 text-xs text-secondary">
                                        <i class="bi bi-calendar3 me-2"></i>
                                        {{ format_created_at(form.created_at) }}
                                    </div>

                                    <div
                                        class="col-12 col-sm-3 col-lg-3 d-flex justify-content-lg-end align-items-center gap-2 flex-nowrap">
                                        <button type="button"
                                            class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                                            data-bs-toggle="modal" data-bs-target="#assign_verification_form_modal"
                                            @click="open_assign_modal(form)">
                                            Assign
                                        </button>
                                        <button type="button"
                                            class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                                            @click="go_to_manual_verification_mapping(form)">
                                            Manage
                                        </button>
                                    </div>
                                </div>
                            </article>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <teleport to="body">
        <div class="modal fade" id="create_verification_form" tabindex="-1"
            aria-labelledby="create_verification_form_label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
                    <div class="modal-header border-bottom-0 cute-header shadow-lg">
                        <p class="modal-title text-white text-xs mb-0" id="create_verification_form_label">Create Form
                        </p>
                        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <div class="modal-form-group form-group mb-3">
                            <label for="verification_form_name" class="modal-form-label form-label text-xs">Form
                                Name:</label>
                            <input type="text" id="verification_form_name" v-model="form_name"
                                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                                placeholder="Please enter a name for the form"
                                aria-labelledby="verification_form_name" />
                        </div>

                        <div class="modal-form-group form-group mb-3">
                            <label for="verification_form_description" class="modal-form-label form-label text-xs">
                                Form Description:
                            </label>
                            <input type="text" id="verification_form_description" v-model="form_description"
                                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                                placeholder="Please enter a description for the form"
                                aria-labelledby="verification_form_description" />
                        </div>
                    </div>

                    <div class="modal-footer border-0 p-2 d-flex justify-content-end">
                        <button type="button"  class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                            @click="create_form" :disabled="create_form_running">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="assign_verification_form_modal" tabindex="-1"
            aria-labelledby="assign_verification_form_modal_label" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content bg-white rounded-4 p-0 shadow-lg border-0">
                    <div class="modal-header border-bottom-0 cute-header shadow-lg">
                        <div class="d-flex align-items-center text-white text-x gap-2">
                            <p class="modal-title  mb-0" id="assign_verification_form_modal_label">
                                Link onboarding forms
                            </p>
                            <span v-if="selected_assign_verification_form?.form_name">
                                {{ selected_assign_verification_form.form_name }}
                            </span>
                        </div>
                        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>

                    <div class="modal-body p-3 p-md-4">
                        <div v-if="loading_onboarding_forms || loading_linked_onboarding_forms"
                            class="text-secondary text-xs">
                            Loading onboarding forms...
                        </div>

                        <div v-else-if="!(assign_modal_forms || []).length" class="text-secondary text-xs">
                            No onboarding forms found.
                        </div>

                        <div v-else class="d-flex flex-column gap-2">
                            <div v-for="form in assign_modal_forms" :key="form.id"
                                class="d-flex align-items-start justify-content-between gap-3 p-3 rounded-4 border bg-white shadow-sm">
                                <div class="min-w-0">
                                    <div class="fw-semibold text-x text-truncate">
                                        {{ form.form_name || 'Untitled Form' }}
                                    </div>
                                    <div class="text-secondary text-xs">
                                        {{ form.form_description || 'No description provided.' }}
                                    </div>
                                </div>

                                <div class="d-flex align-items-center gap-2 flex-shrink-0">
                                    <small class="text-secondary text-xxs"
                                        v-if="linking_onboarding_form_id === form.id">
                                        {{ linking_onboarding_form_action === 'unlink' ? 'Unlinking...' : 'Linking...' }}
                                    </small>
                                    <div class="form-check form-switch m-0">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            :id="`onboarding-link-${form.id}`"
                                            :disabled="linking_onboarding_form_id === form.id"
                                            :checked="Boolean(onboarding_links?.[String(form.id)])"
                                            @change="on_toggle_link(form, $event.target.checked)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </teleport>
</div>
